import StudyInfo from './StudyInfo';

export default StudyInfo;
